define((require) => {
    var _          = require("underscore"),
        $          = require("jquery"),
        Marionette = require("marionette");

    /**
     * @param {HTMLElement} el html element container
     */
    return Marionette.View.extend({
        AMOUNT_OF_MICRO_INCREMENTS_PER_INCREMENT: 9,

        SPACING_CSS_PROPERTY: null,

        DISTANCE_CSS_PROPERTY: null,

        className: "",

        MAJOR_INCREMENT_CLASS_NAME: "ruler-increment",
        MAJOR_INCREMENT_SELECTOR: ".ruler-increment",

        SUB_INCREMENT_CLASS_NAME: "ruler-sub-increment",
        SUB_INCREMENT_SELECTOR: ".ruler-sub-increment",

        /**
         * Get the increment gap for a given scaleFactor.
         * See acceptance criteria for MOS-2553.
         * @static
         * @param {Number} scaleFactor example 1 for 100%, 0.67 for 67%
         * @returns {Number} unscaled gap between major increments. `1000` for scaleFactor of 0.25, `100` for any other scaleFactor
         */
        getMajorIncrementGapPx: function(scaleFactor) {
            if (scaleFactor === 0.25) {
                return 1000;
            }

            return 100;
        },

        getSubIncrementGapPx: function(scaleFactor) {
            return this.getMajorIncrementGapPx(scaleFactor) / (this.AMOUNT_OF_MICRO_INCREMENTS_PER_INCREMENT + 1); // +1 as there will be 1 more gap than markers
        },

        getDefaultRenderOptions: function() {
            return {
                scale: 1,
                marginAtStartPx: 0
            };
        },

        /**
         * Create a ruler element
         * @param {Number} rulerDimensionSize example 900 for 900px ruler
         * @param {Number} scaleFactor example 1 for 100%, 0.67 for 67%
         * @returns {JQuery} jQuery `div` element containing the ruler
         */
        _createRuler: function(rulerDimensionSize, scaleFactor) {
            var $listHtmlElement = $("<ul></ul>").addClass("list-unstyled ruler-elements-list");

            var firstIncrementValue = 0,
                lastIncrementValue = Math.floor(rulerDimensionSize / this.getMajorIncrementGapPx(scaleFactor)) * this.getMajorIncrementGapPx(scaleFactor);

            // make the numbered (major) increments and append to $html
            this._appendMajorIncrements($listHtmlElement, firstIncrementValue, rulerDimensionSize, scaleFactor);

            // make the sub-increments between 2 major increments and append to the major increments
            var $rulerIncrements = $listHtmlElement.find(this.MAJOR_INCREMENT_SELECTOR);
            this._appendSubIncrements($rulerIncrements);

            // make the sub-increments after the last major increment and prepend to the last major increment
            this._appendSubIncrementsAfterLastIncrement($listHtmlElement, rulerDimensionSize, lastIncrementValue, scaleFactor);

            // apply scaled padding
            this._applyScaledPadding($listHtmlElement, scaleFactor);

            return $("<div></div>").addClass("ruler " + this.className).append($listHtmlElement);
        },

        /**
         *
         * @param {JQuery} $listHtmlElement
         * @param {Number} scaleFactor example 0.67
         */
        _applyScaledPadding: function($listHtmlElement, scaleFactor) {
            var self = this,
                $incrementElements = $listHtmlElement.find(this.MAJOR_INCREMENT_SELECTOR + "," + this.SUB_INCREMENT_SELECTOR);

            $incrementElements.each((incrementNumberFromStartOfActiveExperience, incrementElement) => {
                var realPixelsAlong = incrementNumberFromStartOfActiveExperience * self.getSubIncrementGapPx(scaleFactor),
                    currentIncrementPositionAlongRuler = self._getPositionAlongRuler(realPixelsAlong, scaleFactor);

                $(incrementElement).css(self.DISTANCE_CSS_PROPERTY, currentIncrementPositionAlongRuler);
            });
        },

        /**
         * Append sub increments after the last major increment
         * @param {JQuery} $listHtmlElement
         * @param {Number} rulerHighestBound how high the ruler goes. example 85
         * @param {Number} lastIncrementValue example 80
         * @param {Number} scaleFactor example 0.67 (67%)
         */
        _appendSubIncrementsAfterLastIncrement: function($listHtmlElement, rulerHighestBound, lastIncrementValue, scaleFactor) {
            var amountOfSubIncrementsAfterLastIncrement = Math.ceil((Math.abs(rulerHighestBound) - Math.abs(lastIncrementValue)) / this.getSubIncrementGapPx(scaleFactor)),
                $lastLi = $listHtmlElement.find(this.MAJOR_INCREMENT_SELECTOR).last(),
                $newSubIncrementMarkers,
                self = this;

            if (amountOfSubIncrementsAfterLastIncrement !== 0) {
                $newSubIncrementMarkers = _.range(amountOfSubIncrementsAfterLastIncrement).map((number) => {
                    var nextIncrementIsMinorIncrement = (number + 1) % (self.AMOUNT_OF_MICRO_INCREMENTS_PER_INCREMENT + 1);

                    if (nextIncrementIsMinorIncrement !== 0) {
                        return $("<li></li>").addClass(self.SUB_INCREMENT_CLASS_NAME);
                    }

                    var value = lastIncrementValue + self.getMajorIncrementGapPx(scaleFactor);
                    return self._createIncrementMarkerListItem(value);
                });
                $lastLi.after($newSubIncrementMarkers);
            }
        },

        _createIncrementMarkerListItem: function(value) {
            var $incrementText = $("<li></li>").addClass("ruler-px-value").text(value),
                $incrementMarker = $("<li></li>").addClass("ruler-increment-marker");

            return $("<li></li>")
                .addClass(this.MAJOR_INCREMENT_CLASS_NAME)
                .append($incrementText)
                .append($incrementMarker);
        },

        /**
         * Append major increments onto an Html Element
         * @param {JQuery} $listHtmlElement `<ul>` html element
         * @param {Number} firstIncrementValue example -100
         * @param {Number} rulerHighestBound example 4650
         * @param {Number} scaleFactor example 0.67 (67%), 1 (100%)
         */
        _appendMajorIncrements: function($listHtmlElement, firstIncrementValue, rulerHighestBound, scaleFactor) {
            for (var incrementValue = firstIncrementValue; incrementValue <= rulerHighestBound; incrementValue += this.getMajorIncrementGapPx(scaleFactor)) {
                $listHtmlElement.append(this._createIncrementMarkerListItem(incrementValue));
            }
        },

        /**
         * Append sub-increments in place (on the existing object)
         * @param {JQuery[]} $rulerIncrements major increments on the ruler
         */
        _appendSubIncrements: function($rulerIncrements) {
            var self = this;

            $rulerIncrements.each((index, element) => {
                // build the last part of the ruler (after the last major increment) later on
                if (index + 1 === $rulerIncrements.length) {
                    return;
                }

                var subIncrementMarkerElements = _.range(self.AMOUNT_OF_MICRO_INCREMENTS_PER_INCREMENT).map(() => {
                    return $("<li></li>").addClass(self.SUB_INCREMENT_CLASS_NAME);
                });

                $(element).after(subIncrementMarkerElements);
            });
        },

        /**
         *
         * @param {number} realPixelsAlong pixels along in the experience (example 300 would be at the end of a 300px experience, regardless of the scaleFactor)
         * @param {number} scaleFactor 0.67 (67%), 1 (100%), 3 (300%)
         * @returns {number} scaled down pixel value
         */
        _getPositionAlongRuler: function(realPixelsAlong, scaleFactor) {
            return (realPixelsAlong) * scaleFactor;
        },

        /**
         * @param {number[]} offsets
         */
        setMarkers: function(offsets) {
            var self = this;

            this.$el.find(".marker").remove();

            var $markers = _.map(offsets, (offset) => {
                var $element = $("<div></div>")
                    .addClass("marker")
                    .css(self.DISTANCE_CSS_PROPERTY, offset);

                return $element;
            });

            this.$el.children(".ruler").eq(0).append($markers);
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/ruler/AbstractRulerView.js